import toSentences from './toSentences';
import bySpeaker from './bySpeaker';

export default (source) => {
  const sourceBySpeaker = bySpeaker(source);
  sourceBySpeaker.value.forEach((speakerBlock) => {
    speakerBlock.value = toSentences(speakerBlock.value).value;
  });
  return sourceBySpeaker;
};
